import getConfig from "config/config";

export const isInvestCompany = (): boolean => {
  const { company } = getConfig();
  return company.COMPANY_ID === 11;
};

export const isInternationalCompany = (): boolean => {
  const { company } = getConfig();
  return company.COMPANY_ID === 24;
};

export const isMalaysiaCompany = (): boolean => {
  const { company } = getConfig();
  return company.COMPANY_ID === 23;
};
